import ActionMetaBuilder from 'storeState/ActionMetaBuilder';

export const PREFIX = "USERS";

export const actionMeta = new ActionMetaBuilder(PREFIX);

actionMeta.defineRequest({
  name: "users_list",
  urlBuilder: ({tenant_id}) => 'auth/users?tenant_id='+(tenant_id ? tenant_id : '')
});

actionMeta.defineRequest({
    name: "user_delete",
    urlBuilder: ({user_id}) => 'auth/users/'+user_id
});

actionMeta.defineRequest({
    name: "user_create",
    urlBuilder: () => 'auth/users'
});

actionMeta.defineRequest({
    name: "user_update",
    urlBuilder: ({user_id}) => 'auth/users/'+user_id
});



// WEBPACK FOOTER //
// ./src/storeState/users/meta.js